import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { UserActivityFilterOptionsDTO } from '../UserActivity.meta';
import { queryKeys } from './queryKeys';

interface CancelablePromise extends Promise<UserActivityFilterOptionsDTO> {
  cancel(): void;
}

export const fetchActivityFilterOptions = (clientId: string, hideAutomatic: boolean) => {
  const controller = new AbortController();
  const { signal } = controller;

  const promise = authFetch(
    urlWithParams('/Consumer/ActivityLog/FilterOptions', {
      clientId,
      hideAutomatic,
    }),
    {
      signal,
    },
  ) as CancelablePromise;

  promise.cancel = () => controller.abort();

  return promise;
};

export const useActivityFilterOptionsQuery = (
  clientId: string,
  hideAutomatic: boolean,
  enabled: boolean,
) => {
  return useQuery(
    queryKeys.activityFilterOptions(clientId, hideAutomatic),
    () => fetchActivityFilterOptions(clientId, hideAutomatic),
    {
      cacheTime: 0,
      enabled,
    },
  );
};
